<script lang="ts" setup>
import { computed } from 'vue'
import { LocationAsRelativeRaw, RouteLocationRaw, RouterLinkProps, useRoute } from 'vue-router'

export interface Props extends RouterLinkProps {
    to: RouteLocationRaw
    customActiveClass?: string
    noBackground?: boolean
    regularLink?: boolean
    noPadding?: boolean
}

const props = withDefaults(defineProps<Props>(), { noBackground: false, regularLink: false })
const emit = defineEmits<{ (e: 'click'): void }>()

const route = useRoute()
const active = computed(() => {
    const toName = ((props.to as LocationAsRelativeRaw)?.name || '') as string

    if (!toName) return false

    const currentRouteName = (route.name || '') as string

    const isCompanyRoute = toName === 'packaging.balance' || toName.endsWith('.companies')
    if (isCompanyRoute && currentRouteName.endsWith('customers.show')) {
        return true
    }

    return currentRouteName.includes(toName)
})
</script>

<template>
    <RouterLink
        :to="props.to"
        :class="{
            'hover:scale-110 hover:text-primary-500 dark:hover:text-yellow-500':
                !noBackground && !active,
            'text-right uppercase lg:text-center lg:normal-case': !regularLink,
            'py-3 px-6 lg:py-3 lg:px-6': !noPadding && !active,

            'py-4 px-10 lg:py-4 lg:px-12': !noPadding && active,
            // Active state: prominent yellow background with dark text for maximum visibility
            'font-extrabold bg-yellow-500 text-dark-900 border-l-8 border-yellow-600 rounded-xl shadow-lg dark:bg-yellow-500 dark:text-dark-900 dark:border-yellow-400 lg:bg-yellow-500 lg:border-r-8 lg:border-yellow-600 lg:rounded':
                active,
        }"
        exact-active-class="pointer-events-none"
        class="cursor-pointer border-transparent transition-all duration-300 ease-out transform origin-left hover:scale-110 active:scale-90 text-gray-700 dark:text-primary-200 hover:text-primary-700 dark:hover:text-yellow-500 rounded-lg font-heavy dark:hover:shadow-dark-900/50"
        @click="emit('click')"
    >
        <slot />
    </RouterLink>
</template>
